export default __webpack_public_path__ + "static/Reel-68c594c743812954a221ab755b554250.jpg";